import React from 'react';
import BravoLogo from '../../../Elements/BravoLogo';

function BravoLogoDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>
          The mark follows the active theme — toggle dark mode in the profile menu to see it swap
        </div>
      </div>
      <div className='dsg-row'>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 28 }}>
          <BravoLogo className='dsg-logo-sm' />
          <BravoLogo className='dsg-logo-md' />
          <BravoLogo className='dsg-logo-lg' />
        </div>
      </div>
    </div>
  );
}

export const bravoLogoDemo = {
  id: 'bravo-logo',
  title: 'Brand mark',
  category: 'Foundation',
  importPath: 'Elements/BravoLogo',
  notes: [
    'Renders BOTH sources and toggles them with CSS (.bravo-logo-light / .bravo-logo-dark) rather than picking one in JS: a /public asset cannot be referenced from a CSS url() (css-loader resolves it at build time and the build fails), and swapping src on a theme change flashes while the new file loads. The hidden one is display:none, so it stays out of the accessibility tree.',
    'Size it from the call site with className — the component sets no dimensions.',
    'The rules are unscoped (like .figmabutton), because the mark is used outside .bravo-ds subtrees too.',
    'Exports LOGO_LIGHT_SRC / LOGO_DARK_SRC for the rare caller that wants one fixed variant regardless of theme — the holiday loader paints the navy mark on its own backdrop.',
    'Consumers: BravoLoader (the loading mark) and StandalonePage (the brand lockup).',
  ],
  snippet: "<BravoLogo className='my-logo' />  /* .my-logo { width: 46px; height: 50px; } */",
  render: BravoLogoDemoComponent,
};
